<template>
  <!--权益 -->
  <div class="wrapper">
    <!-- 被保险人 -->
    <div class="base">
      <div class="title">被保险人</div>
      <div class="content">
        <div class="item" v-for="(item,index) in obj.insuresList" style="position:relative">
          <div class="num" v-if="obj.insuresList&&obj.insuresList.length>1">
            <span>{{index+1}}</span>
          </div>
          <div class="top clearfix">
            <div class="its">
              <div class="label">姓名</div>
              <div class="value">{{item.name}}</div>
            </div>
            <div class="its">
              <div class="label">性别</div>
              <div class="value">{{item.sex | filterSex}}</div>
            </div>
            <div class="its">
              <div class="label">证件类型</div>
              <div class="value">{{item.cardType | filterCardType}}</div>
            </div>
            <div class="its">
              <div class="label">证件号</div>
              <div class="value">{{item.cardNumber}}</div>
            </div>
            <div class="its">
              <div class="label">手机号</div>
              <div class="value">{{item.mobile}}</div>
            </div>
            <div class="its">
              <div class="label">与投保人关系</div>
              <div class="value">{{item.relationToHolder | filterRelationShip}}</div>
            </div>
          </div>
          <div class="list">
            <div class="title clearfix">
              <div class="left">保障项目</div>
              <div class="right">保额/详情</div>
            </div>
            <ul v-if="obj.rightList">
              <li class="clearfix" v-for="(its,idx) in computedRightList[index].rightList" :key="idx">
                <span>{{its.rightName}}</span>
                <span>{{its.rightValue}}</span>
              </li>
              <!-- <li class="clearfix">
                <span>25种中症疾病保险金</span>
                <span>6万元</span>
              </li>
              <li class="clearfix">
                <span>25种中症疾病保险金</span>
                <span>6万元</span>
              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 受益人 -->
    <div class="rights">
      <div class="title">受益人</div>
      <div class="desc">
        <span style="color: #727C8E;">受益人类型：</span>
        <lzDicTxt style="color: #272933;" dicType="BENEFICIARY_TYPE" :dicCode="obj.beneficiaryType"></lzDicTxt>
      </div>
      <div class="content" v-if="obj.beneficiaryType == 2">
        <Table :columns="columns" :data="obj.beneficiaryList" border></Table>
      </div>
    </div>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import filter from "@/api/filter";
export default {
  components: {lzDicTxt},
  props: ["obj"],
  data() {
    return {
      columns: [
        {
          title: "姓名",
          key: "name",
          align: "center"
        },
        {
          title: "证件号码",
          key: "cardNumber",
          align: "center"
        },
        {
          title: "与被保险人关系",
          key: "relationToHolder",
          align: "center",
          render(h, params) {
            const value = filter.filterRelationShip(
              params.row.relationToHolder
            );
            return <span>{value}</span>;
          }
        },
        {
          title: "受益比例",
          key: "rate",
          align: "center",
          render(h, params) {
            return <span>{params.row.rate + "%"}</span>;
          }
        }
      ]
    };
  },
  watch: {},
  computed: {
    computedRightList(){
        let arr = []
        this.obj.insuresList.forEach(item=>{
            const num = item.md5CardNumber
            this.obj.rightList.forEach(item2=>{
                if(num==item2.insuresCardNo){
                  arr.push(item2)
                }
            })
        })
        return arr
    }
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "./interests.scss";
.num {
  position: absolute;
  width: 0;
  height: 0;
  /* 设置边框 */
  border: 20px solid;
  top: 0;

  /* 边框颜色 */
  border-color: #ff7134 transparent transparent #ff7134;
  left: 0;
  span {
    position: absolute;
    top: -17px;
    left: -10px;
    color: #fff;
  }
}
</style>